import { render } from "./BuildingDetail.vue?vue&type=template&id=6a3e8dc8&scoped=true"
import script from "./BuildingDetail.vue?vue&type=script&lang=js"
export * from "./BuildingDetail.vue?vue&type=script&lang=js"

import "./BuildingDetail.vue?vue&type=style&index=0&id=6a3e8dc8&scoped=true&lang=css"

import exportComponent from "/Users/shohei/workspace/soei_project/measure_rep_mng/vue3_measure_rep_mng/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a3e8dc8"]])

export default __exports__